// extracted by mini-css-extract-plugin
export var alternate = "AdditionalResources-module--alternate--f0438";
export var blogPost = "AdditionalResources-module--blog-post--f3b5d";
export var content = "AdditionalResources-module--content--82788";
export var culturePost = "AdditionalResources-module--culture-post--a7891";
export var custom = "AdditionalResources-module--custom--d6453";
export var customerStory = "AdditionalResources-module--customer-story--b4b24";
export var deepDive = "AdditionalResources-module--deep-dive--19cb8";
export var engineeringPost = "AdditionalResources-module--engineering-post--a53cb";
export var gold = "AdditionalResources-module--gold--dff6c";
export var guide = "AdditionalResources-module--guide--2ec1f";
export var productSnapshots = "AdditionalResources-module--product-snapshots--2831c";
export var resource = "AdditionalResources-module--resource--56ebe";
export var section = "AdditionalResources-module--section--94ab1";
export var video = "AdditionalResources-module--video--96549";
export var white = "AdditionalResources-module--white--79a52";